import { PropsWithChildren, ReactNode } from 'react';

import { Typography, Stack } from '@cast/design-system';

type SectionProps = PropsWithChildren<{
  title: string;
  action?: ReactNode;
  testId?: string;
}>;

export const Section = ({ title, action, children, testId }: SectionProps) => {
  return (
    <Stack gap={8} data-testid={testId}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="A1" color="textSecondary">
          {title}
        </Typography>
        {action}
      </Stack>

      {children}
    </Stack>
  );
};
